// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__t+c5H","tyre":"style_tyre__iM0bA"};